<div class="chat-history-container">
  <div class="conversations-list">
    <!-- Show all conversations without grouping when not searching and not showing all -->
    <div *ngIf="!searchQuery.trim() && !showAllConversations">
      <div class="conversation-items">
        <div 
          *ngFor="let conversation of getLimitedConversations(getAllConversationsFlat(), sidebarPreviewLimit)" 
          class="conversation-item position-relative"
          [class.active]="isActiveConversation(conversation.id)"
          (click)="onConversationClick(conversation.id)"
        >
          <div class="conversation-content">
            <div class="conversation-title text-capitalize">{{ conversation.title }}</div>
                <div class="btn-group position-absolute top-0 end-0 p-2" style="display: none;" dropdown container="body" (click)="$event.stopPropagation()">
                  <i class="fa-solid fa-ellipsis-h dropdown-toggle ellipsis-btn fs-5" role="button" dropdownToggle
                    data-toggle="dropdown" aria-expanded="true"></i>
                  <div class="dropdown-menu dropdown-menu-start" *dropdownMenu>
                    <!-- Show Confirm option for New Patient or Established appointments -->
                
                    <span class="dropdown-item" role="button" (click)="deleteConversation(conversation.id, $event)">
                      <i class="fa fa-trash-can me-2"></i>
                      Delete
                    </span>
                  </div>
                </div>
          </div>
        </div>
        
        <!-- Show "Show all conversations" link if there is at least one conversation -->
        <div class="show-all-link" [class.active]="isActiveConversation('all')" *ngIf="getAllConversationsFlat().length > sidebarPreviewLimit">
          <a role="button" (click)="onConversationClick('all')">
            All Conversations
          </a>
        </div>
      </div>
    </div>
     <div *ngIf="showAllConversations">
       <div class="search-container w-40">
         <div class="search-input-wrapper">
           <i class="fal fa-search search-icon"></i>
           <input type="text" class="search-input" placeholder="Search conversations" [value]="searchQuery"
             (input)="onSearchChange($event)">
         </div>
       </div>
       
       <!-- Show grouped conversations when not searching -->
       <div *ngIf="!searchQuery.trim()">
        <div *ngIf="isLoading">
          <app-loader [loadingMessage]="'Loading...'" [allowFullHeight]="true"></app-loader>
        </div>
        <div *ngIf="!isLoading && groupedConversations.length === 0" class="empty-state">
          <div class="empty-icon">
            <i class="fas fa-comments"></i>
          </div>
          <div class="empty-text">No conversations yet.</div>
        </div>
         <div *ngFor="let group of groupedConversations" class="conversation-group mb-5">
          <!-- App Loader -->
          
          
          <!-- Main Content -->
           <div class="ms-3"><h3 class="fw-bold text-capitalize">{{ group.period }}</h3></div>
           <div class="conversation-items">
             <div 
               *ngFor="let conversation of group.conversations" 
               class="conversation-item ps-3 border-bottom"
               [class.active]="isActiveConversation(conversation.id)"
               (click)="onConversationClick(conversation.id)"
             >
               <div class="conversation-content py-2">
                 <h4 class="conversation-title text-capitalize text-dark fw-bold fs-5">{{ conversation.title }}</h4>
                 <div class="conversation-preview fs-6" *ngIf="conversation.lastMessage">
                   {{ truncateText(conversation.lastMessage, 100) }}
                 </div>
               </div>
               <div class="conversation-time d-flex align-items-center gap-3">
                 {{ formatTime(conversation.timestamp) }}
               </div>
             </div>
           </div>
         </div>
       </div>
       
       <!-- Show filtered conversations when searching -->
       <div *ngIf="searchQuery.trim()">
         <div class="conversation-group">
           <div class="conversation-items">
             <div 
               *ngFor="let conversation of filteredConversations" 
               class="conversation-item"
               (click)="onConversationClick(conversation.id)"
             >
               <div class="conversation-content">
                 <div class="conversation-title">{{ conversation.title }}</div>
                 <div class="conversation-preview" *ngIf="conversation.lastMessage">
                   {{ truncateText(conversation.lastMessage, 60) }}
                 </div>
               </div>
               <div class="conversation-time d-flex align-items-center gap-2">
                 {{ formatTime(conversation.timestamp) }}
                 <div class="btn-group" dropdown container="body">
                   <i class="fa-solid fa-ellipsis-vertical dropdown-toggle ellipsis-btn" role="button" dropdownToggle
                     data-toggle="dropdown" aria-expanded="true"></i>
                   <div class="dropdown-menu dropdown-menu-end" *dropdownMenu>
                     <span class="dropdown-item" role="button" (click)="deleteConversation(conversation.id, $event)">
                       <i class="fa fa-trash-can me-2"></i>
                       Delete
                     </span>
                   </div>
                 </div>
               </div>
             </div>
           </div>
         </div>
       </div>
       
       <!-- Empty state for search -->
       <div *ngIf="searchQuery.trim() && filteredConversations.length === 0" class="empty-state">
         <div class="empty-icon">
           <i class="fas fa-comments"></i>
         </div>
         <div class="empty-text">No conversations found</div>
       </div>
    </div>
  </div>
</div>
